export const withRetry = async <T>(fn: () => Promise<T>, retries: number, delay?: number): Promise<T | undefined> => {
  let retryCount = 0;
  while (retryCount < retries) {
    try {
      return await fn();
    } catch (error) {
      if (retryCount >= retries - 1) {
        throw error;
      }
      if (delay) {
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
      retryCount++;
    }
  }
};
